import classNames from 'classnames';
import * as React from 'react';
import { FC } from 'react';

type PropsType = {
  icon?: string,
  image: string,
  imageWidth: number,
  imageClassName: string
}

const MenuItemImage: FC<PropsType> = ({
  icon,
  image,
  imageWidth,
  imageClassName,
}) => {
  if (icon) {
    return <i className={classNames(icon, imageClassName)} />;
  }
  if (!image) {
    return null;
  }
  return <img src={image} width={imageWidth} className={imageClassName} />;
};

export { MenuItemImage };
